import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import optionsCacheCheckerAndLoader from '@pages/AdditionalServices/containers/services/optionsCacheCheckerAndLoader';
import optionsGenerator from '@pages/AdditionalServices/containers/services/optionsGenerator';
import { SelectOption } from '@pages/AdditionalServices/containers/services/optionsGenerator/types';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';
import { v4 } from 'uuid';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { getLoadTypes } from '../../getLoadTypes';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * GlobalOptionsProcessor формирует стейт опций для всех полей виджета
 */
export class GlobalOptionsProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param _
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    _: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const loadTypes = getLoadTypes(additionalServiceState.FieldsToDisplay);

    const id = v4();
    const state = { ...optionsState };

    const values = await Promise.all(
      loadTypes.map(async (conf) => {
        return {
          type: conf.type,
          cache: await optionsCacheCheckerAndLoader().LoadCacheForNewData(
            conf.type,
            !state.Cache[conf.type].isPartialLoading,
            Object.keys(state.Cache[conf.type]),
            conf.id
          ),
        };
      })
    );

    const newState = {
      ...state,
      Loadings: state.Loadings.filter((l) => l !== id),
    };

    if (
      additionalServiceState.FieldsToDisplay &&
      additionalServiceState.FieldsToDisplay.length > 0
    ) {
      newState.FieldsToCalculateState = [...additionalServiceState.FieldsToDisplay];
    }

    values.map((val) => {
      if (!val.cache.isPartialLoading) {
        newState.Cache[val.type] = val.cache;
        return;
      }

      if (Object.keys(val.cache.cache).length === 0) {
        return;
      }

      if (!state.Cache[val.type].isPartialLoading) {
        return;
      }

      newState.Cache[val.type] = {
        isPartialLoading: true,
        cache: {
          ...newState.Cache[val.type].cache,
          ...val.cache.cache,
        },
      };
    });

    const options: { [T in string]: SelectOption[] } = { ...newState.FieldOptions };
    newState.FieldsToCalculateState.map((field) => {
      options[field.code] = optionsGenerator().getOptions(
        field,
        newState.LangID,
        newState.Cache[field.type]
      );
    });

    return {
      isValid: true,
      additionalServiceState,
      optionsState: { ...newState, FieldOptions: options },
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState,
    };
  }
}
